import { useEffect } from "react";

import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

import * as Events from "@app/common/events";
import ROUTES from "@app/common/routes";

const ROUTE_MIGRATIONS: { route: string; redirect?: string }[] = [
  { route: "dashboard", redirect: ROUTES.LANDING_PAGE },
  { route: "meetops/collaboration" },
  { route: "meetops/explore" },
  { route: "meetops/overview", redirect: ROUTES.PERSONAL_MEETING_POLICY },
  { route: "preferences", redirect: ROUTES.USER_SETTINGS_INTEGRATIONS }, // old calendar preferences page
  { route: "meetings", redirect: ROUTES.REPORTS },
  { route: "meetings/shared", redirect: ROUTES.SHARED_REPORTS },
  { route: "meetings/incomplete", redirect: ROUTES.INCOMPLETE_REPORTS },
  { route: "meetings/search", redirect: ROUTES.REPORTS_SEARCH },
];

const NotFound = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (window.location.href.includes(ROUTES.NOT_FOUND)) return;
    Events.pageNotFound({ attempted_url: window.location.href });
    navigate(ROUTES.NOT_FOUND);
  }, []);

  return null;
};

/**
 * Dumping ground for all deprecated /analytics routes
 * */
const RouteMigrations = () => (
  <Routes>
    {ROUTE_MIGRATIONS.map(({ route, redirect = ROUTES.LANDING_PAGE }) => (
      <Route
        key={route}
        path={route}
        element={
          <Navigate
            to={{ pathname: redirect, search: window.location.search }}
            replace
          />
        }
      />
    ))}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default RouteMigrations;
